import { Loader, Select, SelectProps, Text } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useDeferredValue, useState } from "react";
import { UsersSearchRepository } from "shared/components/organization/users/data";
import { some } from "shared/utils/maybe";
import { UserStatus } from "src/gql/graphql";
import { container } from "tsyringe";
import { z } from "zod";

export const UserSearch = (props: SelectProps & { status?: UserStatus }) => {
    const [search, setSearch] = useState("");
    const nameQuery = useDeferredValue(search);
    const loader = container.resolve(UsersSearchRepository).get({ nameQuery, status: props.status });
    const data = loader.useItems();
    const { isLoading } = loader.useStatus();

    function serializeContactInfo(contactInfo: { name?: string; loginEmail?: string }) {
        return JSON.stringify(contactInfo);
    }

    function deserializeContactInfo(serialized: string) {
        return z
            .object({
                name: z.string().nullish(),
                loginEmail: z.string().nullish(),
            })
            .parse(JSON.parse(serialized));
    }

    return (
        <Select
            searchable
            value={null}
            onSearchChange={setSearch}
            rightSection={isLoading ? <Loader size="xs" color="gray" type="oval" /> : undefined}
            leftSection={<IconSearch size={16} />}
            data={data
                ?.flat()
                .map((each) => ({ value: each.id, label: serializeContactInfo({ name: each.name, loginEmail: each.loginEmail }) }))}
            renderOption={({ option }) =>
                some(option.label)
                    .map(deserializeContactInfo)
                    .take(({ name, loginEmail }) => (
                        <div>
                            <Text size="sm" fw={600}>
                                {name}
                            </Text>
                            <Text c="dimmed" size="xs">
                                {loginEmail ?? <em>No email</em>}
                            </Text>
                        </div>
                    ))
            }
            {...props}
        />
    );
};
